import { Controller } from "stimulus"
import { Ajax } from "ajax"

export default class extends Controller {

  static targets = [ "globalCount", "newsCount", "setNewsRead" ]
  static values = { globalCount: Number, newsCount: Number, setNewsReadUrl: String }

  setNewsRead(e) {
    Ajax.post(this.setNewsReadUrlValue, {}).then(response => {
      response.json().then(data => {
        this.newsCountValue = 0
        this.globalCountValue = data
      })
    });
  }

  globalCountValueChanged() {
    this.globalCountTargets.forEach((el, i) => {
      if (this.globalCountValue > 0) {
        el.innerText = this.globalCountValue
        el.classList.remove('hidden')
      } else {
        el.innerText = this.globalCountValue
        el.classList.add('hidden')
      }
    })
  }

  newsCountValueChanged() {
    this.newsCountTargets.forEach((el, i) => {
      if (this.newsCountValue > 0) {
        el.innerText = this.newsCountValue
        el.classList.remove('hidden')
      } else {
        el.innerText = this.newsCountValue
        el.classList.add('hidden')
      }
    })
  }

}